import type { DataTableColumnProps } from '../../DataTableColumn';

export interface ExportColumn {
	name: string;
	header: string;
}

export function buildExportColumns<T>(columns: DataTableColumnProps<T>[]): ExportColumn[] {
	return columns
		.filter(col => !col.excludeFromExport)
		.map(col => {
			const header = col.exportHeader ?? (typeof col.header === 'string' ? col.header : undefined);
			if (header === undefined) {
				throw new Error(`Export: column '${col.key}' has a non-string header; set exportHeader or excludeFromExport.`);
			}
			return { name: col.exportColumnName ?? col.key, header };
		});
}
